// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2525":"e49c7cc0","2892":"bbde118d"}[chunkId] + ".chunk.css";
};